import { SiteSection } from '../SiteSection.js';

/**
 * What a month looks like (§19).
 *
 * Every number on this page is **illustrative and says so**, twice: in the
 * heading of the sheet and in the line beneath it. It is laid out as the
 * statement it stands for — a sheet of paper, one figure a line — rather than
 * as a row of tiles. The charter forbids
 * inventing customers, results or statistics (§54), and a ROI block with
 * confident figures and no source is the most effective way to invent all
 * three at once.
 *
 * The terminology is the product's own, and it is the part that will still be
 * right in a year: **valeur de réservations associée**, never "chiffre
 * d'affaires". They are different numbers — one is the price of the
 * appointments taken, the other is money received — and the dashboard keeps
 * them in separate columns for the same reason.
 */

const FIGURES: readonly (readonly [string, string, string])[] = [
  ['237', 'appels récupérés', 'Arrivés en débordement ou hors horaires, et décrochés.'],
  ['93', 'rendez-vous créés', 'Réellement inscrits dans l’agenda du salon.'],
  [
    '3 045 €',
    'de valeur de réservations associée',
    'Le prix des rendez-vous pris. Pas un encaissement.',
  ],
  [
    '6 h 42',
    'de téléphone pris en charge',
    'Estimation prudente : un appel transféré compte zéro.',
  ],
  ['87 %', 'de demandes abouties', 'Une demande comprise n’est pas une demande aboutie.'],
];

export function RoiExample(): React.JSX.Element {
  return (
    <SiteSection
      title="Ce que le mois vous a rapporté."
      intro={
        <p>
          Le tableau de bord répond à une seule question : qu’est-ce que cela vous a rapporté ce
          mois-ci ?
        </p>
      }
    >
      <div className="rounded-[14px] border border-wall-line bg-surface">
        <div className="border-b border-wall-line px-5 py-5 sm:px-8">
          <p className="text-ui font-medium text-ink">Exemple de relevé mensuel</p>
          <p className="mt-1 max-w-xl text-ui-sm text-ink-muted">
            Chiffres d’illustration. GSI Voice ne publie aucun résultat client sans son accord et
            sans données réelles.
          </p>
        </div>

        <dl className="divide-y divide-wall-line">
          {FIGURES.map(([value, label, note]) => (
            <div
              key={label}
              className="grid gap-x-8 gap-y-1 px-5 py-5 sm:grid-cols-[10.5rem_1fr] sm:items-baseline sm:px-8"
            >
              <dt className="text-ui font-medium text-ink sm:col-start-2 sm:row-start-1">
                {label}
              </dt>
              <dd className="sign-figure order-first text-sign-sm text-ink sm:order-none sm:col-start-1 sm:row-span-2 sm:row-start-1">
                {value}
              </dd>
              <dd className="text-ui-sm text-ink-muted sm:col-start-2">{note}</dd>
            </div>
          ))}
        </dl>
      </div>
    </SiteSection>
  );
}
